import Attorney from './Attorney';

export default Attorney;
